module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "pt1",
      "epub:type": "part",
      "role": "doc-part"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "PT",
    attrs: {
      "id": "pt1"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "5",
      "id": "pg_5",
      "role": "doc-pagebreak"
    }
  }, [_c('samp', {
    staticClass: "SANS_Baruta_Black_B_17"
  }, [_vm._v("INTRODUCTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Intro"
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("When I tell people that I work as an illustrator, it’s not always easy to describe my job or explain what I do. It has been—and still is—an exciting journey, and for me, one of the perks of being an illustrator is that it’s an ever-challenging and constantly new experience. Drawing is, of course, at the core of my work. I’ve always loved drawing. Like many, I started when I was still a child. I vividly remember drawing in my primary school books, filling them with sketches and impressions, and I feel like I’ve never stopped.")])]), _vm._v(" "), _c('p', {
    staticClass: "Intro"
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Of course, my practice has evolved since then. During my academic studies back in Italy, I fell in love with watercolor, which has become my favorite artistic technique by far, and I started to explore photography as well.")])]), _vm._v(" "), _c('p', {
    staticClass: "Intro"
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Photography eventually led me to fashion, and not long after, I decided to move to Paris, where I briefly worked in the womenswear department of a trend-forecasting agency. During that time, I felt like all of my interests could be combined in fashion illustration, and from that moment on I’ve worked hard to make this my full-time job. Over the years I’ve also trained as a teacher, led some classes in Italy, and, more recently, tutored a monthly fashion life-drawing class for over two years in London. It has been a very enriching experience, and I see this book as the natural following step.")])]), _vm._v(" "), _c('figure', {
    staticClass: "IMG-NOBOT"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "917",
      "src": "images/pg5.jpg",
      "width": "560"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ab456b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1.vue
// module id = 66
// module chunks = 0